import { render, staticRenderFns } from "./AddProjectStep1.vue?vue&type=template&id=71d2fb65&"
import script from "./AddProjectStep1.vue?vue&type=script&lang=js&"
export * from "./AddProjectStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports